import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Image from "next/image";

import { colors } from "../../utils/const";

const rootSx = {
  flex: "1 1 0",
  p: 4,
  textAlign: "center",
};

const headingWrapperSx = {
  position: "relative",
  display: "inline-block",
  zIndex: 1,
};

const headingSx = {
  color: colors.orange,
  mt: 2,
  fontWeight: "bold",
};

const descriptionSx = {
  margin: "auto",
  mt: 1,
  fontWeight: "bold",
  color: colors.blue,
  whiteSpace: "pre-wrap",
  width: { xs: "100%", md: "75%" },
};

const iconSx = { width: "38px", height: "38px", objectFit: "contain" };

/**
 * One of the "vision / mission / values" cards on the About page.
 */
export default function AboutValueCard({ icon, alt, heading, desc }) {
  return (
    <Box sx={rootSx}>
      {icon && (
        <Image
          src={icon}
          alt={alt || ""}
          width={100}
          height={100}
          quality={80}
          loading="lazy"
          style={iconSx}
        />
      )}
      <br />

      <Box sx={headingWrapperSx}>
        <Typography component="h3" variant="h5" sx={headingSx} gutterBottom>
          {heading}
        </Typography>
      </Box>

      <Typography variant="subtitle2" component="p" sx={descriptionSx}>
        {desc}
      </Typography>
    </Box>
  );
}
